import { createCommunicationSelectors } from 'src/helpers/redux'
import { IState, PREFIX, TGlobalStateWithService } from './state'
import { actions } from './actions'
import { createSelector } from 'reselect'

export const selectCommunication = (
  state: TGlobalStateWithService
): IState['communication'] => state[PREFIX].communication

export const selectGlobalSearch = (
  state: TGlobalStateWithService
): IState['globalSearchObject'] => state[PREFIX].globalSearchObject

export const communications = createCommunicationSelectors<
  TGlobalStateWithService,
  IState['communication'],
  typeof actions
>(selectCommunication, actions)

export const selectors = {
  globalSearchResult: createSelector(selectGlobalSearch, (state) => state),
}
